import React, { useState } from 'react';

/**
 * Dismissible in-app re-engagement banner (dual-channel nudge, channel 2).
 *
 * The nudge object arrives on the launch-time GET /subscription response
 * (surfaced via SubscriptionContext). It is written onto the user's PROFILE
 * row by recallNudgeHandler when the user goes quiet, and cleared when they
 * return. Styled in the app's toast/design language: accent border, soft
 * shadow, close button. Dismiss is tracked per-nudge in localStorage so it
 * stays gone until a newer nudge (different id) is issued.
 */
export default function InAppNudge({ nudge }) {
  const storageKey = nudge ? `nudgeDismissed:${nudge.id}` : null;
  const [dismissed, setDismissed] = useState(() => {
    if (!storageKey) return true;
    try {
      return localStorage.getItem(storageKey) === '1';
    } catch {
      return false;
    }
  });

  if (!nudge || !nudge.id || dismissed) return null;

  const handleDismiss = () => {
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      /* non-fatal */
    }
    setDismissed(true);
  };

  return (
    <div className="inapp-nudge" role="status">
      <div className="inapp-nudge-body">
        {nudge.title && <div className="inapp-nudge-title">{nudge.title}</div>}
        {nudge.body && <div className="inapp-nudge-text">{nudge.body}</div>}
      </div>
      <button
        type="button"
        className="inapp-nudge-close"
        aria-label="Dismiss"
        onClick={handleDismiss}
      >
        ×
      </button>
    </div>
  );
}
